import angular from 'angular';
import signatureVerifyComponent from './signature-verify.component';
import signatureTpl from './signature-verify.html'
import errorTpl from './signature-error.html'
import successTpl from './signature-success.html'

let signatureVerifyModule = angular.module('signature-verify', [])

    .component('signatureVerify', signatureVerifyComponent)

.name;

let states = [
    {
        name: 'tsa',
        url: '/tsa',
        abstract: true,
        component: 'signatureVerify'
    },
    {
        name: 'tsa.form',
        url: '',
        template: signatureTpl,
        title: 'home-evidences-text040'
    },
    {
        name: 'tsa.error',
        url: '/error',
        template: errorTpl,
        title: 'home-evidences-text040'
    },
    {
        name: 'tsa.success',
        url: '/success',
        template: successTpl,
        title: 'home-evidences-text040'
    }
];

export default {name: signatureVerifyModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/verify/signature-verify/signature-verify.js